/**
 * Created by wwei on 2018-01-24.
 */

const Settings = {
  LOCALIZATION: false,
  PDMS_DEV_URL:
    "https://www.service-dev.pdms.plcm.cloud/api/rest/v1/user/login",
  PDMS_QA_URL: "https://www.service-qa.pdms.plcm.cloud/api/rest/v1/user/login",
  LICENSE_AGREEMENT_URL:
    "https://support.polycom.com/content/dam/polycom-support/global/agreements/polycom-cloud-terms-of-service.pdf",
  HELP_DOC_URL:
    "https://documents.polycom.com/bundle/plcm-cloud-current/page/c1475823.html",
  DOMAIN_BLACKLIST: [
    "@outlook.com",
    "@gmail.com",
    "@hotmail.com",
    "@yahoo.com",
    "@onmicrosoft.com",
    "@live.com",
    "@inbox.com",
    "@icloud.com",
    "@mail.com",
    "@aol.com",
    "@zoho.com",
    "@yandex.com",
    "@comcast.net"
  ],
  PRIVACY_URL: "http://www.polycom.com/company/privacy.html",
  CR_AGREEMENT_URL:
    "http://documents.polycom.com/sites/default/files/static/eula/PolycomEndUserLicenseAgreementALLPRODUCTS.pdf",
  A4B_URL: "https://aws.amazon.com/alexaforbusiness/",
  LICENSE_RENEW_LINK:
    "https://documents.polycom.com/bundle/pcs-licensing-renewal/page/pcs-licensing-renewal/pcs-licensing-renewal/pcs-licensing-renewal.htm"
};

export default Settings;



// WEBPACK FOOTER //
// ./src/common/Settings.js